module.exports = __webpack_public_path__ + "static/media/category8.78a78a15.jpg";